declare global {
    interface Window {
        dataLayer: Record<string, any>[];
    }
}

export const populateDataLayerGA = function(user: any) {
    try {
        if (user) {
            const fotmatedUserData = formatUserData(user);
            window.dataLayer.push({
                event: "dataLayerLoaded",
                ...fotmatedUserData
            });
        }
    } catch (e) {
        console.log("GA Error init")
    }
};

const formatUserData = (userData: any) => {
    const [firstName, ...lastName] = userData.name.toLowerCase().split(" ");

    return {
        email: userData.email ? userData.email : "",
        birth: userData.birth,
        endPlan: userData.position.subscriberUntil,
        isSubscriber: new Date() < new Date(userData.position.subscriberUntil),
        userId: userData.id,
        phone: userData.phone && userData.phone.length > 0 ? (userData.phone || "").replace(/[\s()-]/g, "") : "",
        first_name: firstName,
        last_name: lastName.join(" "),
        city: userData.city ? (userData.city || "").replace(" ", "").toLowerCase() : "",
        state: userData.uf ? (userData.uf || "").toLowerCase() : "",
        zip_code: userData.cep ? (userData.cep || "").replace("-", "") : "",
        country: "br",
        createdAt: userData.createdAt,
        profile: userData.role.toString(),
        url: window.location.href,
        isB2B: userData.isB2B || false,
        B2BCompany: userData.B2BCompany

        // cursos inscritos regulares e nao regulares
        // onboarding todos os campos
        // quantidade de redações enviadas
        // data do ultimo envio de redação
        // perfil (admin ou aluno)
    };
};
